<template>
  <ReportBaseSelectFilter
    class="client-type-filter"
    label="Source"
    placeholder="All sources"
    :options="clientTypeOptions"
    query-property="client_types"
  />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReportClientTypeFilter',
  computed: {
    ...mapGetters(['clientTypeOptions']),
  },
};
</script>
